"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Dropdown", {
  enumerable: true,
  get: function get() {
    return _Dropdown.default;
  }
});
Object.defineProperty(exports, "DropdownConsumer", {
  enumerable: true,
  get: function get() {
    return _withContext.Consumer;
  }
});
exports.DropdownControl = void 0;
Object.defineProperty(exports, "useDropdownContext", {
  enumerable: true,
  get: function get() {
    return _withContext.useDropdownContext;
  }
});
Object.defineProperty(exports, "withDropdownContext", {
  enumerable: true,
  get: function get() {
    return _withContext.withDropdownContext;
  }
});
var _Dropdown = _interopRequireDefault(require("./Dropdown"));
var _DropdownBody = require("./DropdownBody");
var _withContext = require("./withContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var DropdownControl = exports.DropdownControl = (0, _withContext.withDropdownContext)(_Dropdown.default);
var Components = {
  Body: _DropdownBody.DropdownBody
};
Object.assign(_Dropdown.default, Components);
Object.assign(DropdownControl, Components);